/**
 * Every route the Ride to Rebuild campaign renders.
 * Pages navigate by this enum rather than by literal paths so the
 * campaign's URL surface has one definition.
 */
export enum CharityRoute {
  Campaign = "/charity",
  Join = "/charity/join",
  SignIn = "/charity/signin",
  Report = "/charity/report",
  Reports = "/charity/reports",
  Household = "/charity/household",
  Leaderboard = "/charity/leaderboard",
  HowItWorks = "/charity/how-it-works",
  HowToJoin = "/charity/how-it-works/joining",
  HowToScreenshotApps = "/charity/how-it-works/apps",
  HowToReport = "/charity/how-it-works/reporting",
  HowToGroupRide = "/charity/how-it-works/group-rides",
  RideTogether = "/charity/ride-together",
  Rules = "/charity/rules",
  Privacy = "/charity/privacy",
  AdminQueue = "/charity/admin",
  AdminExport = "/charity/admin/export",
}
